import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { ISearchState } from "./types";

export { createSearchedTextChangedAction } from "./actions";
export { SET_SEARCH_RESULTS } from "./constants";
export { getSearchedText, getSearchResults, isSearchActive } from "./selectors";
export { SearchGroup, SearchResult, SearchResultType } from "./types";

export const searchModule: ApplicationStatefulModule<typeof NAME, Reducer<ISearchState>> = {
    NAME,
    reducer,
    saga,
};
